import { Container } from "@material-ui/core";
import { Link } from "react-router-dom";

function TrustCentreHome() {
    return (
        <Container>
            <h1>Trust Centre</h1>
            <p>
                <Link to="/trustcentre/privacy">Privacy Policy</Link>
            </p>
            <p>
                <Link to="/trustcentre/cookies">Cookie Policy</Link>
            </p>
            <p>
                <Link to="/trustcentre/termsofuse">Terms of Use Policy</Link>
            </p>
            <p>
                <Link to="/trustcentre/acceptableuse">Acceptable Use Policy</Link>
            </p>
        </Container>
    );
}

export default TrustCentreHome;
